// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"59472780","74":"102766fd","81":"90cdccac","96":"599eb3a2","176":"828dc4e2","254":"62ba4c61","330":"bfdb0d9c","349":"7052ee14","695":"fdbb7f3a","700":"fbaf818f","753":"8314dafd","769":"981e5a5a","987":"bde3f0dc"}[chunkId] + ".chunk.js";
};